import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, field } from '@simonbackx/simple-encoding';
import { GroupPriceDiscount } from './GroupPriceDiscount.js';
import { TranslatedString } from './TranslatedString.js';
/**
 * Indicates that a certain bundle discount is activated for a certain group price.
 * It also allows you to override the discount amount for this group price.
 */
export class BundleDiscountGroupPriceSettings extends AutoEncoder {
    /**
     * Cached name of this bundle discount.
     */
    name = new TranslatedString();
    customDiscounts = null;
}
__decorate([
    field(TranslatedString.field({}))
], BundleDiscountGroupPriceSettings.prototype, "name", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(GroupPriceDiscount), nullable: true })
], BundleDiscountGroupPriceSettings.prototype, "customDiscounts", void 0);
//# sourceMappingURL=BundleDiscountGroupPriceSettings.js.map